import React from 'react';
import { Link } from 'react-router-dom';

export function Unavailable() {
	return (
		<main className="mx-auto max-w-2xl px-6 lg:px-8 py-8">
			<div className="rounded-2xl border border-gray-200 bg-white shadow-sm elev-1 p-6">
				<h1 className="text-2xl font-extrabold text-gray-900">Portal is unavailable</h1>
				<p className="mt-2 text-sm text-gray-700">
					The customer portal is currently disabled. Please try again later or contact support.
				</p>
				<div className="mt-4">
					<Link to="/custportal/login" className="rounded-xl bg-sedra px-4 py-2.5 text-sm font-semibold text-white hover:bg-sedra-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sedra">
						Go to login
					</Link>
				</div>
			</div>
		</main>
	);
} 